import { createContainer } from 'react-sweet-state';

import { PageStore } from './PageStore';

export const PageStoreContainer = createContainer(PageStore, {
  onInit:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
